
import React, { useState, useEffect, useRef } from 'react';
import { format } from 'date-fns';
import config from '../../config';
import Header from '../Header';
import Footer from '../Footer';
import { useApi } from '../../ApiContext';
import PopupService from '../PopupService';
import { apiFetch } from '../utils/ApiFetch';
const PAGE_SIZE = 20;
const PAGE_GROUP_SIZE = 10;



const supportAlertFieldsOrder = [
  { key: 'mrNumber', label: 'MR Number' },
  { key: 'alertTitle', label: 'Alert Title' },
  { key: 'alertClass', label: 'Alert Class' },
  { key: 'alertSource', label: 'Alert Source' },
  { key: 'alertType', label: 'Alert Type' },
  { key: 'category', label: 'Category' },
  { key: 'manufacturer', label: 'Manufacturer' },
  { key: 'productDesc', label: 'Product Description' },
  { key: 'publishDate', label: 'Publish Date', isDate: true },
  { key: 'entryTimeStamp', label: 'Upload Date', isDate: true },
  { key: 'contactInfo', label: 'Contact Info' },
  { key: 'distribution', label: 'Distribution' },
  { key: 'reason', label: 'Reason' },
  { key: 'recaller', label: 'Recaller' },
  { key: 'recommendedAction', label: 'Recommended Action' },
  { key: 'sourceNumber', label: 'Source Number' },
  { key: 'sourceUrl', label: 'Source URL' },
  { key: 'upc', label: 'UPC' },
  { key: 'ndc', label: 'NDC' },
  { key: 'quantity', label: 'Quantity' },
  { key: 'miscInfo', label: 'Misc Info' },
];

function ManualAlertsTable({
  manualSearch,
  setManualSearch,
  manualPage,
  setManualPage,
  manualTotalPages,
  manualTotalRecords,
  manualInputPage,
  setManualInputPage,
  manualData,
  manualLoading,
  fetchManualAlerts,
  fetchAlertDetail,
  manualSearchInputRef,
}) {
  const currentGroup = Math.floor((manualPage - 1) / PAGE_GROUP_SIZE);
  const startPage = currentGroup * PAGE_GROUP_SIZE + 1;
  const endPage = Math.min(startPage + PAGE_GROUP_SIZE - 1, manualTotalPages);
  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);

  const handleManualSearch = () => {
    setManualPage(1);
    fetchManualAlerts(1, manualSearch);
    if (manualSearchInputRef.current) manualSearchInputRef.current.focus();
  };
  

 

  return (
    <div>
      <div className="input-group mb-3" style={{ maxWidth: 400 }}>
	    <input
          type="text"
          className="form-control"
          placeholder="Search alerts..."
          value={manualSearch}
          onChange={e => setManualSearch(e.target.value)}
          ref={manualSearchInputRef}
          autoFocus
        />
        <button
          className="btn btn-secondary"
          type="button"
          onClick={handleManualSearch}
        >
          Search
        </button>
        <button
          className="btn btn-secondary"
          onClick={() => {
            setManualSearch('');
            setManualPage(1);
            fetchManualAlerts(1, '');
            if (manualSearchInputRef.current) manualSearchInputRef.current.focus();
          }}
        >
          <i className='fa fa-times'></i>
        </button>
      </div>
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>MR Number</th>
			<th>Manufacturer</th>
            <th>Alert Title</th>
            <th>Alert Class</th>
			<th>Source No.</th>
            <th>Publish Date</th>
          </tr>
        </thead>
        <tbody>
          {manualLoading ? (
            <tr><td colSpan={5}>Loading...</td></tr>
          ) : manualData.length === 0 ? (
            <tr><td colSpan={5}>No data available</td></tr>
          ) : (
            manualData.map((row, idx) => (
              <tr key={row.mrNumber || idx}>
                <td>{(manualPage - 1) * PAGE_SIZE + idx + 1}</td>
                <td className="text-nowrap">
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault();
                      fetchAlertDetail(row.mrNumber, 'manual');
                    }}
                  >
                    {row.mrNumber}
                  </a>
                </td>

				<td>
				  {row.recaller
				    ? (
				      <>
				        <span class="text-info">Manufacturer:</span> {row.manufacturer}<br />
				        <span class="text-primary">Recaller:</span> {row.recaller}
				      </>
				    )
				    : row.manufacturer
				  }
				</td>

                <td>{row.alertTitle}</td>
                <td>{row.alertClass}</td>
				<td>{row.sourceNumber}</td>
                <td>{row.publishDate ? format(new Date(row.publishDate), 'MM/dd/yyyy') : ''}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <span className="text-secondary">
          Showing page {manualPage} of {manualTotalPages} ({manualTotalRecords} total records)
        </span>
        <nav>
          <ul className="pagination mb-0">
            <li className={`page-item${manualPage === 1 ? ' disabled' : ''}`}>
              <button className="page-link text-secondary" onClick={() => setManualPage(1)} disabled={manualPage === 1}>
                &laquo;
              </button>
            </li>
            <li className={`page-item${manualPage === 1 ? ' disabled' : ''}`}>
              <button className="page-link text-secondary" onClick={() => setManualPage(manualPage - 1)} disabled={manualPage === 1}>
                Previous
              </button>
            </li>
            {pageNumbers.map(page => (
              <li key={page} className={`page-item${manualPage === page ? ' active' : ''}`}>
                <button
                  className={`page-link text-secondary${manualPage === page ? ' text-light bg-secondary' : ''}`}
                  onClick={() => setManualPage(page)}
                >
                  {page}
                </button>
              </li>
            ))}
            <li className={`page-item${manualPage === manualTotalPages ? ' disabled' : ''}`}>
              <button className="page-link text-secondary" onClick={() => setManualPage(manualPage + 1)} disabled={manualPage === manualTotalPages}>
                Next
              </button>
            </li>
            <li className={`page-item${manualPage === manualTotalPages ? ' disabled' : ''}`}>
              <button className="page-link text-secondary" onClick={() => setManualPage(manualTotalPages)} disabled={manualPage === manualTotalPages}>
                &raquo;
              </button>
            </li>
            <li>
              <div className="pagination-jump d-flex align-items-center ms-2">
                <input
                  type="number"
                  min={1}
                  max={manualTotalPages}
                  value={manualInputPage}
                  onChange={e => setManualInputPage(e.target.value)}
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      const page = Number(e.target.value);
                      if (page >= 1 && page <= manualTotalPages) setManualPage(page);
                    }
                  }}
                  className="form-control form-control-sm"
                  style={{ width: 90 }}
                  placeholder="Page #"
                />
                <button
                  className="btn btn-sm btn-success ms-1"
                  onClick={() => {
                    const page = Number(manualInputPage);
                    if (page >= 1 && page <= manualTotalPages) setManualPage(page);
                  }}
                  disabled={!manualInputPage || Number(manualInputPage) < 1 || Number(manualInputPage) > manualTotalPages}
                >
                  Go
                </button>
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}



function DuplicateAlertsTable({
  duplicateSearch,
  setDuplicateSearch,
  duplicatePage,
  setDuplicatePage,
  duplicateTotalPages,
  duplicateTotalRecords,
  duplicateInputPage,
  setDuplicateInputPage,
  duplicateData,
  duplicateLoading,
  fetchDuplicateAlerts,
  fetchAlertDetail,
  duplicateSearchInputRef,
}) {
  const currentGroup = Math.floor((duplicatePage - 1) / PAGE_GROUP_SIZE);
  const startPage = currentGroup * PAGE_GROUP_SIZE + 1;
  const endPage = Math.min(startPage + PAGE_GROUP_SIZE - 1, duplicateTotalPages);
  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);

  const handleDuplicateSearch = () => {
    setDuplicatePage(1);
    fetchDuplicateAlerts(1, duplicateSearch);
    if (duplicateSearchInputRef.current) duplicateSearchInputRef.current.focus();
  };

  return (
    <div>
	<footer className="blockquote-footer text-primary">For 'and'' search: <b>(catheter cardinal)</b>, 'or' search no bracket <b>catheter cardinal</b>. 
		For combined search follow the example: '<b>catheter cath and guiding gdng and baxter cardinal</b>' which means '(catheter or cath) and 
		(guiding or gdng) and (baxter or cardunal)' </footer>
      <div className="input-group mb-3" style={{ maxWidth: 400 }}>
	   
        <input
          type="text"
          className="form-control"
          placeholder="Search duplicate alerts..."
          value={duplicateSearch}
          onChange={e => setDuplicateSearch(e.target.value)}
          ref={duplicateSearchInputRef}
        />
        <button
          className="btn btn-secondary"
          type="button"
          onClick={handleDuplicateSearch}
        >
          <i className="fa fa-search"></i>
        </button>
        <button
          className="btn btn-secondary"
          onClick={() => {
            setDuplicateSearch('');
            setDuplicatePage(1);
            fetchDuplicateAlerts(1, '');
            if (duplicateSearchInputRef.current) duplicateSearchInputRef.current.focus();
          }}
        >
          <i className='fa fa-times'></i>
        </button>
      </div>
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>MR Number</th>
			<th>Manufacturer</th>
            <th>Alert Title</th>
            <th>Alert Class</th>
			<th>Source No.</th>
            <th>Publish Date</th>
          </tr>
        </thead>
        <tbody>
          {duplicateLoading ? (
            <tr><td colSpan={5}>Loading...</td></tr>
          ) : duplicateData.length === 0 ? (
            <tr><td colSpan={5}>No data available</td></tr>
          ) : (
            duplicateData.map((row, idx) => (
              <tr key={row.mrNumber || idx}>
                <td>{(duplicatePage - 1) * PAGE_SIZE + idx + 1}</td>
                <td className="text-nowrap">
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault();
                      fetchAlertDetail(row.mrNumber, 'manual');
                    }}
                  >
                    {row.mrNumber}
                  </a>
                </td>
				<td dangerouslySetInnerHTML={{ __html: row.recaller
				  ? `<span class="text-info">Manufacturer:</span> ${row.manufacturer}<br /><span class="text-primary">Recaller:</span> ${row.recaller}`
				  : row.manufacturer || "" }} />
				<td dangerouslySetInnerHTML={{ __html: row.alertTitle || "" }} />
                <td>{row.alertClass}</td>
				<td>{row.sourceNumber}</td>
                <td>{row.publishDate ? format(new Date(row.publishDate), 'MM/dd/yyyy') : ''}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <span className="text-secondary">
          Showing page {duplicatePage} of {duplicateTotalPages} ({duplicateTotalRecords} total records)
        </span>
        <nav>
          <ul className="pagination mb-0">
            <li className={`page-item${duplicatePage === 1 ? ' disabled' : ''}`}>
              <button className="page-link text-secondary" onClick={() => setDuplicatePage(1)} disabled={duplicatePage === 1}>
                &laquo;
              </button>
            </li>
            <li className={`page-item${duplicatePage === 1 ? ' disabled' : ''}`}>
              <button className="page-link text-secondary" onClick={() => setDuplicatePage(duplicatePage - 1)} disabled={duplicatePage === 1}>
                Previous
              </button>
            </li>
            {pageNumbers.map(page => (
              <li key={page} className={`page-item${duplicatePage === page ? ' active' : ''}`}>
                <button
                  className={`page-link text-secondary${duplicatePage === page ? ' text-light bg-secondary' : ''}`}
                  onClick={() => setDuplicatePage(page)}
                >
                  {page}
                </button>
              </li>
            ))}
            <li className={`page-item${duplicatePage === duplicateTotalPages ? ' disabled' : ''}`}>
              <button className="page-link text-secondary" onClick={() => setDuplicatePage(duplicatePage + 1)} disabled={duplicatePage === duplicateTotalPages}>
                Next
              </button>
            </li>
            <li className={`page-item${duplicatePage === duplicateTotalPages ? ' disabled' : ''}`}>
              <button className="page-link text-secondary" onClick={() => setDuplicatePage(duplicateTotalPages)} disabled={duplicatePage === duplicateTotalPages}>
                &raquo;
              </button>
            </li>
            <li>
              <div className="pagination-jump d-flex align-items-center ms-2">
                <input
                  type="number"
                  min={1}
                  max={duplicateTotalPages}
                  value={duplicateInputPage}
                  onChange={e => setDuplicateInputPage(e.target.value)}
                  onKeyDown={e => {
                    // No search on Enter
                  }}
                  className="form-control form-control-sm"
                  style={{ width: 90 }}
                  placeholder="Page #"
                />
                <button
                  className="btn btn-sm btn-success ms-1"
                  onClick={() => {
                    const page = Number(duplicateInputPage);
                    if (page >= 1 && page <= duplicateTotalPages) setDuplicatePage(page);
                  }}
                  disabled={!duplicateInputPage || Number(duplicateInputPage) < 1 || Number(duplicateInputPage) > duplicateTotalPages}
                >
                  Go
                </button>
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}


function FDAAlertTable({
  fdaSearch,
  setFdaSearch,
  fdaPage,
  setFdaPage,
  fdaTotalPages,
  fdaTotalRecords,
  fdaInputPage,
  setFdaInputPage,
  fdaData,
  fdaLoading,
  fetchFDAAlerts,
  fetchAlertDetail,
}) {
  const currentGroup = Math.floor((fdaPage - 1) / PAGE_GROUP_SIZE);
  const startPage = currentGroup * PAGE_GROUP_SIZE + 1;
  const endPage = Math.min(startPage + PAGE_GROUP_SIZE - 1, fdaTotalPages);
  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);

  return (
    <div>
      <div className="input-group mb-3" style={{ maxWidth: 400 }}>
        <input
          type="text"
          className="form-control"
          placeholder="Search FDA alerts..."
          value={fdaSearch}
          onChange={e => setFdaSearch(e.target.value)}
        />
        <button
          className="btn btn-secondary"
          type="button"
          onClick={() => { setFdaPage(1); fetchFDAAlerts(1, fdaSearch); }}
        >
          Search
        </button>
        <button
          className="btn btn-secondary"
          onClick={() => { setFdaSearch(''); setFdaPage(1); fetchFDAAlerts(1, ''); }}
        >
          <i className='fa fa-times'></i>
        </button>
      </div>
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th className="text-nowrap">FDA Number</th>
            <th>Source</th>
            <th>Title</th>
            <th className="text-nowrap">Source Number</th>
            <th className="text-nowrap">Publish Date</th>
          </tr>
        </thead>
        <tbody>
          {fdaLoading ? (
            <tr><td colSpan={6}>Loading...</td></tr>
          ) : fdaData.length === 0 ? (
            <tr><td colSpan={6}>No data available</td></tr>
          ) : (
            fdaData.map((row, idx) => (
              <tr key={row.alertId || idx}>
                <td>{(fdaPage - 1) * PAGE_SIZE + idx + 1}</td>
                <td className="text-nowrap">
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault();
                      fetchAlertDetail(row.alertId, 'fda');
                    }}
                  >
                    {row.alertId}
                  </a>
                </td>
                <td>{row.source}</td>
                <td>{row.title}</td>
                <td>{row.sourceNumber}</td>
                <td className="text-nowrap">{row.publishDate ? format(new Date(row.publishDate), 'MM/dd/yyyy') : ''}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <span className="text-secondary">
          Showing page {fdaPage} of {fdaTotalPages} ({fdaTotalRecords} total records)
        </span>
        <nav>
          <ul className="pagination mb-0">
            <li className={`page-item${fdaPage === 1 ? ' disabled' : ''}`}>
              <button className="page-link text-secondary" onClick={() => setFdaPage(1)} disabled={fdaPage === 1}>
                &laquo;
              </button>
            </li>
            <li className={`page-item${fdaPage === 1 ? ' disabled' : ''}`}>
              <button className="page-link text-secondary" onClick={() => setFdaPage(fdaPage - 1)} disabled={fdaPage === 1}>
                Previous
              </button>
            </li>
            {pageNumbers.map(page => (
              <li key={page} className={`page-item${fdaPage === page ? ' active' : ''}`}>
                <button
                  className={`page-link text-secondary${fdaPage === page ? ' text-light bg-secondary' : ''}`}
                  onClick={() => setFdaPage(page)}
                >
                  {page}
                </button>
              </li>
            ))}
            <li className={`page-item${fdaPage === fdaTotalPages ? ' disabled' : ''}`}>
              <button className="page-link text-secondary" onClick={() => setFdaPage(fdaPage + 1)} disabled={fdaPage === fdaTotalPages}>
                Next
              </button>
            </li>
            <li className={`page-item${fdaPage === fdaTotalPages ? ' disabled' : ''}`}>
              <button className="page-link text-secondary" onClick={() => setFdaPage(fdaTotalPages)} disabled={fdaPage === fdaTotalPages}>
                &raquo;
              </button>
            </li>
            <li>
              <div className="pagination-jump d-flex align-items-center ms-2">
                <input
                  type="number"
                  min={1}
                  max={fdaTotalPages}
                  value={fdaInputPage}
                  onChange={e => setFdaInputPage(e.target.value)}
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      const page = Number(e.target.value);
                      if (page >= 1 && page <= fdaTotalPages) setFdaPage(page);
                    }
                  }}
                  className="form-control form-control-sm"
                  style={{ width: 90 }}
                  placeholder="Page #"
                />
                <button
                  className="btn btn-sm btn-success ms-1"
                  onClick={() => {
                    const page = Number(fdaInputPage);
                    if (page >= 1 && page <= fdaTotalPages) setFdaPage(page);
                  }}
                  disabled={!fdaInputPage || Number(fdaInputPage) < 1 || Number(fdaInputPage) > fdaTotalPages}
                >
                  Go
                </button>
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}

const AlertRepository = () => {
  const manualSearchInputRef = useRef(null);
  const username = sessionStorage.getItem("username");
  const mrToken = localStorage.getItem("mr_token");
  const { callApi, setIsApiLoading } = useApi();
  const [activeTab, setActiveTab] = useState('tab1');
  const [alertDetail, setAlertDetail] = useState(null);
  const [editField, setEditField] = useState({});
  const [editLoading, setEditLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  // Manual Alerts Table State
  const [manualData, setManualData] = useState([]);
  const [manualSearch, setManualSearch] = useState('');
  const [manualPage, setManualPage] = useState(1);
  const [manualTotalPages, setManualTotalPages] = useState(1);
  const [manualTotalRecords, setManualTotalRecords] = useState(0);
  const [manualInputPage, setManualInputPage] = useState('');
  const [manualLoading, setManualLoading] = useState(false);

  // FDA Alerts Table State
  const [fdaData, setFdaData] = useState([]);
  const [fdaSearch, setFdaSearch] = useState('');
  const [fdaPage, setFdaPage] = useState(1);
  const [fdaTotalPages, setFdaTotalPages] = useState(1);
  const [fdaTotalRecords, setFdaTotalRecords] = useState(0);
  const [fdaInputPage, setFdaInputPage] = useState('');
  const [fdaLoading, setFdaLoading] = useState(false);
  
  // Duplicate Alerts Table State
   const [duplicateData, setDuplicateData] = useState([]);
   const [duplicateSearch, setDuplicateSearch] = useState('');
   const [duplicatePage, setDuplicatePage] = useState(1);
   const [duplicateTotalPages, setDuplicateTotalPages] = useState(1);
   const [duplicateTotalRecords, setDuplicateTotalRecords] = useState(0);
   const [duplicateInputPage, setDuplicateInputPage] = useState('');
   const [duplicateLoading, setDuplicateLoading] = useState(false);
   const duplicateSearchInputRef = useRef(null);

  useEffect(() => {
    if (activeTab === 'tab1') {
      fetchManualAlerts(1, manualSearch);
    } else if (activeTab === 'tab2') {
      fetchFDAAlerts(1, fdaSearch);
    }
    // eslint-disable-next-line
  }, [activeTab]);

  useEffect(() => {
    fetchManualAlerts(1, manualSearch);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (activeTab === 'tab1') {
      fetchManualAlerts(manualPage, manualSearch);
    }
    // eslint-disable-next-line
  }, [manualPage]);

  useEffect(() => {
    if (activeTab === 'tab2') fetchFDAAlerts(fdaPage, fdaSearch);
    // eslint-disable-next-line
  }, [activeTab, fdaPage]);
  useEffect(() => {
    if (activeTab === 'tab3') {
      fetchDuplicateAlerts(duplicatePage, duplicateSearch);
    }
    // eslint-disable-next-line
  }, [activeTab, duplicatePage]);
  
  const fetchDuplicateAlerts = async (page = 1, search = '') => {
    setDuplicateLoading(true);
    setLoading(true);
    await callApi(async () => {
      setIsApiLoading(true);
      try {
        const response = await apiFetch(`${config.API_BASE_URL}/duplicatealerts`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Username': username,
            'Authorization': `Bearer ${mrToken}`
          },
          body: JSON.stringify({
            pageNo: page,
            limit: PAGE_SIZE,
            sort: 'publishDate',
            sortOrder: 'desc',
            search: search
          })
        });
        if (response.ok) {
          const data = await response.json();
          const list = Array.isArray(data?.data?.SEARCH_LIST) ? data.data.SEARCH_LIST : [];
          setDuplicateData(list);
          const total = data?.data?.TOTAL_HITS || list.length;
          setDuplicateTotalRecords(total);
          setDuplicateTotalPages(Math.ceil(total / PAGE_SIZE) || 1);
          setDuplicatePage(page || 1);
        } else {
          setDuplicateData([]);
          setDuplicateTotalPages(1);
          setDuplicateTotalRecords(0);
        }
      } finally {
        setDuplicateLoading(false);
        setLoading(false);
        setIsApiLoading(false);
      }
    });
  };

  const fetchManualAlerts = async (page = 1, search = '') => {
    setManualLoading(true);
    setLoading(true);
    await callApi(async () => {
      setIsApiLoading(true);
      try {
        const response = await apiFetch(`${config.API_BASE_URL}/supportalerts`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Username': username,
            'Authorization': `Bearer ${mrToken}`
          },
          body: JSON.stringify({
            pageNo: page,
            limit: PAGE_SIZE,
            sort: 'publishDate',
            sortOrder: 'desc',
            search: search
          })
        });
        if (response.ok) {
          const data = await response.json();
          const list = Array.isArray(data?.data?.SEARCH_LIST) ? data.data.SEARCH_LIST : [];
          setManualData(list);
          const total = data?.data?.QUERY_COUNT || list.length;
          setManualTotalRecords(total);
          setManualTotalPages(Math.ceil(total / PAGE_SIZE) || 1);
          setManualPage(page || 1);
        } else {
          setManualData([]);
          setManualTotalPages(1);
          setManualTotalRecords(0);
        }
      } finally {
        setManualLoading(false);
        setLoading(false);
        setIsApiLoading(false);
      }
    });
  };

  const fetchFDAAlerts = async (page = 1, search = '') => {
    setFdaLoading(true);
    setLoading(true);
    await callApi(async () => {
      setIsApiLoading(true);
      try {
        const response = await apiFetch(`${config.API_BASE_URL}/repalert/searchRepAlert`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Username': username,
            'Authorization': `Bearer ${mrToken}`
          },
          body: JSON.stringify({
            search: search,
            pageNo: page - 1,
            limit: PAGE_SIZE,
            sortOrder: 'desc',
            sort: 'publishDate'
          })
        });
        if (response.ok) {
          const data = await response.json();
          setFdaData(data.results || []);
          setFdaPage(data.currentPage || 1);
          setFdaTotalPages(data.totalPages || 1);
          setFdaTotalRecords(data.totalRecords || 0);
        } else {
          setFdaData([]);
          setFdaTotalPages(1);
          setFdaTotalRecords(0);
        }
      } finally {
        setFdaLoading(false);
        setLoading(false);
        setIsApiLoading(false);
      }
    });
  };

  const fetchAlertDetail = async (alertId, type) => {
    let url = '';
    if (type === 'manual') {
      url = `${config.API_BASE_URL}/repalert/suppoartAlertDetail?alertId=${alertId}`;
    } else {
      url = `${config.API_BASE_URL}/repalert/alertDetail?alertId=${alertId}`;
    }
    setLoading(true);
    await callApi(async () => {
      setIsApiLoading(true);
      try {
        const response = await fetch(url, {
          headers: {
            'Content-Type': 'application/json',
            'X-Username': username,
            'Authorization': `Bearer ${mrToken}`
          }
        });
        if (response.ok) {
          const data = await response.json();
          setAlertDetail(data.data);
          setEditField({});
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }, 0);
        } else {
          setAlertDetail(null);
        }
      } catch {
        setAlertDetail(null);
        setLoading(false);
        setIsApiLoading(false);
      }
    });
  };

  const handleEditField = (fieldName, value) => {
    setEditField({ ...editField, [fieldName]: value });
  };

  const saveEditField = async (mrNumber, fieldName) => {
    setEditLoading(true);
    setLoading(true);
    await callApi(async () => {
      setIsApiLoading(true);
      try {
        const value = editField[fieldName];
        const response = await apiFetch(`${config.API_BASE_URL}/repalert/editSuppportAlertField`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Username': username,
            'Authorization': `Bearer ${mrToken}`
          },
          body: JSON.stringify({
            mrNumber,
            fieldName,
            fieldValue: value
          })
        });
        if (response.ok) {
          fetchAlertDetail(mrNumber, 'manual');
          PopupService.getInstance().showMessage("The edit field " + fieldName + ' Saved Successfully', true);
        } else {
          PopupService.getInstance().showMessage("Edit field " + fieldName + ' Saved Error!', false);
        }
      } finally {
        setEditLoading(false);
        setEditField({});
        setLoading(false);
        setIsApiLoading(false);
      }
    });
  };

  const renderSupportAlertDetail = () => {
    if (!alertDetail || !alertDetail.SUPPORT_ALERT) return null;
    const alert = alertDetail.SUPPORT_ALERT;
    return (
      <div>
        {supportAlertFieldsOrder.map(({ key, label, isDate }) => (
          <div className="row mb-2" key={key}>
            <div className="col-md-3 text-info fw-bold">{label}:</div>
            <div className="col-md-7">
              {key === 'mrNumber' ? (
                alert[key] || ""
              ) : editField[key] !== undefined ? (
                (editField[key] && editField[key].length > 50) ? (
                  <textarea
                    className="form-control"
                    rows={
                      editField[key].length > 500
                        ? 7
                        : editField[key].length > 50
                          ? 3
                          : 1
                    }
                    value={editField[key]}
                    onChange={e => handleEditField(key, e.target.value)}
                  />
                ) : (
                  <input
                    type={isDate ? "date" : "text"}
                    className="form-control"
                    value={editField[key]}
                    onChange={e => handleEditField(key, e.target.value)}
                  />
                )
              ) : (
                key === 'sourceUrl' && alert[key] ? (
                  <a href={alert[key]} target="_blank" rel="noopener noreferrer">
                    {alert[key]}
                  </a>
                ) : (key === 'publishDate' || key === 'entryTimeStamp') && alert[key] ? (
                  format(new Date(alert[key]), "MM/dd/yyyy")
                ) : isDate && alert[key] ? (
                  format(new Date(alert[key]), "yyyy-MM-dd")
                ) : (
                  <span dangerouslySetInnerHTML={{ __html: alert[key] || "" }} />
                )
              )}
            </div>
            <div className="col-md-2">
              {key !== 'mrNumber' && (
                editField[key] !== undefined ? (
                  <>
                    <button title="Save" disabled={editLoading} style={{ cursor: "pointer" }} type="button"
                      className="btn btn-sm btn-outline-danger" onClick={() => saveEditField(alert.mrNumber, key)}>
                      <i className="fa fa-save" />
                    </button>
                    &nbsp;
                    <button type="button" className="btn btn-sm btn-outline-secondary" style={{ cursor: "pointer" }}
                      onClick={() => setEditField(prev => {
                        const newEdit = { ...prev };
                        delete newEdit[key];
                        return newEdit;
                      })} title="Cancel">
                      <i className="fa fa-times" />
                    </button>
                  </>
                ) : (
                  <button type="button" className="btn btn-sm btn-outline-secondary" style={{ cursor: "pointer" }}
                    onClick={() => handleEditField(key, alert[key] || "")}
                    title={`Edit - ${label}`}>
                    <i className="fa fa-edit" />
                  </button>
                )
              )}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderAlertDetail = () => {
    const alertFields = [
      { key: 'alertId', label: 'MR Number' },
      { key: 'title', label: 'Alert Title' },
      { key: 'alertClass', label: 'Alert Class' },
      { key: 'source', label: 'Alert Source' },
      { key: 'publishDate', label: 'Publish Date', isDate: true },
      { key: 'uploadDate', label: 'Upload Date', isDate: true }
    ];
    if (!alertDetail || !alertDetail.alert) return null;

    const firstRowNames = ['Product Description', 'Reason for Recall', 'Code Info', 'Distribution Pattern'];
    const pairs = alertDetail.stringFieldPairs || [];
    const firstRowPairs = firstRowNames
      .map(name => pairs.find(pair => pair.dataName === name))
      .filter(Boolean);
    const restPairs = pairs.filter(pair => !firstRowNames.includes(pair.dataName));

    const fieldChunks = chunkFields(alertFields, 4);
    return (
      <div>
        {fieldChunks.map((chunk, idx) => (
          <div className="row" key={idx}>
            {chunk.map(({ key, label, isDate }) => (
              <div className="form-group col-md-3" key={key}>
                <label className="text-info fw-bold">{label}:</label>
                <div>
                  {isDate && alertDetail.alert[key]
                    ? format(new Date(alertDetail.alert[key]), 'MM/dd/yyyy')
                    : String(alertDetail.alert[key] ?? '')}
                </div>
              </div>
            ))}
          </div>
        ))}
        {firstRowPairs.map((pair, idx) => (
          <div className="row" key={`single-row-${idx}`}>
            <div className="form-group col-md-12">
              <label className="text-info fw-bold">{pair.dataName}</label>
              <div>{pair.dataValue}</div>
            </div>
          </div>
        ))}
        {chunkPairs(restPairs, 4).map((chunk, idx) => (
          <div className="row" key={idx}>
            {chunk.map((pair, i) => (
              <div className="form-group col-md-3" key={i}>
                <label className="text-info fw-bold">{pair.dataName}</label>
                <div>{pair.dataValue}</div>
              </div>
            ))}
            {chunk.length < 4 &&
              Array.from({ length: 4 - chunk.length }).map((_, i) => (
                <div className="form-group col-md-3" key={`empty-${i}`}></div>
              ))}
          </div>
        ))}
      </div>
    );
  };

  const chunkFields = (fields, size = 4) => {
    const chunks = [];
    for (let i = 0; i < fields.length; i += size) {
      chunks.push(fields.slice(i, i + size));
    }
    return chunks;
  };
  const chunkPairs = (pairs, size = 4) => {
    const chunks = [];
    for (let i = 0; i < pairs.length; i += size) {
      chunks.push(pairs.slice(i, i + size));
    }
    return chunks;
  };

  const handleBack = () => {
    setAlertDetail(null);
    setEditField({});
    setTimeout(() => {
      const tabBtn = document.querySelector('.nav-link.active');
      if (tabBtn) tabBtn.focus();
    }, 0);
  };

  return (
    <>
      <Header />
      <div className="container-fluid text-secondary">
        <br /><br /><br />
        {alertDetail && (
          <div id="alert_detail">
            <div className="card">
              <div className="card-body custom-card-bg">
                <div className="card">
                  <div className="card-header">Alert Detail</div>
                  <div className="card-body">
                    <div className="d-flex justify-content-end mb-3">
                      <button className="btn btn-sm btn-secondary" onClick={handleBack}>
                        Back
                      </button>
                    </div>
                    {renderSupportAlertDetail()}
                    {renderAlertDetail()}
                    <button className="btn btn-sm btn-secondary" onClick={handleBack}>
                      Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
        )}
        <div className="card text-secondary">
          <div className="card-header">Alert Repository</div>
          <div className="card-body custom-card-bg">
            <div className="card text-secondary">
              <div className="card-body">
                <ul className="nav nav-tabs">
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === 'tab1' ? 'active' : 'text-secondary'}`}
                      type="button"
                      role="tab"
                      onClick={() => setActiveTab('tab1')}
                    >
                      Manual Alerts
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === 'tab2' ? 'active' : 'text-secondary'}`}
                      onClick={() => setActiveTab('tab2')}
                      type="button"
                      role="tab"
                    >
                      FDA Repository
                    </button>
                  </li>
				  <li className="nav-item" role="presentation">
				      <button
				        className={`nav-link ${activeTab === 'tab3' ? 'active' : 'text-secondary'}`}
				        onClick={() => setActiveTab('tab3')}
				        type="button"
				        role="tab"
				      >
				        Duplicate Search
				      </button>
				    </li>
                </ul>
                <br />
                {activeTab === 'tab1' && (
                  <div className="card" id="manual_alert_div">
                    <div className="card-header">Manual Alert Repository</div>
                    <div className="card-body">
                      <ManualAlertsTable
                        manualSearch={manualSearch}
                        setManualSearch={setManualSearch}
                        manualPage={manualPage}
                        setManualPage={setManualPage}
                        manualTotalPages={manualTotalPages}
                        manualTotalRecords={manualTotalRecords}
                        manualInputPage={manualInputPage}
                        setManualInputPage={setManualInputPage}
                        manualData={manualData}
                        manualLoading={manualLoading}
                        fetchManualAlerts={fetchManualAlerts}
                        fetchAlertDetail={fetchAlertDetail}
                        manualSearchInputRef={manualSearchInputRef}
                      />
                    </div>
                  </div>
                )}
                {activeTab === 'tab2' && (
                  <div className="card" id="fda_alert_div">
                    <div className="card-header">FDA Alert Repository</div>
                    <div className="card-body">
                      <FDAAlertTable
                        fdaSearch={fdaSearch}
                        setFdaSearch={setFdaSearch}
                        fdaPage={fdaPage}
                        setFdaPage={setFdaPage}
                        fdaTotalPages={fdaTotalPages}
                        fdaTotalRecords={fdaTotalRecords}
                        fdaInputPage={fdaInputPage}
                        setFdaInputPage={setFdaInputPage}
                        fdaData={fdaData}
                        fdaLoading={fdaLoading}
                        fetchFDAAlerts={fetchFDAAlerts}
                        fetchAlertDetail={fetchAlertDetail}
                      />
                    </div>
                  </div>
                )}
				{activeTab === 'tab3' && (
				  <div className="card" id="duplicate_alert_div">
				    <div className="card-header">Duplicate Alert Search</div>
				    <div className="card-body">
				      <DuplicateAlertsTable
				        duplicateSearch={duplicateSearch}
				        setDuplicateSearch={setDuplicateSearch}
				        duplicatePage={duplicatePage}
				        setDuplicatePage={setDuplicatePage}
				        duplicateTotalPages={duplicateTotalPages}
				        duplicateTotalRecords={duplicateTotalRecords}
				        duplicateInputPage={duplicateInputPage}
				        setDuplicateInputPage={setDuplicateInputPage}
				        duplicateData={duplicateData}
				        duplicateLoading={duplicateLoading}
				        fetchDuplicateAlerts={fetchDuplicateAlerts}
				        fetchAlertDetail={fetchAlertDetail}
				        duplicateSearchInputRef={duplicateSearchInputRef}
				      />
				    </div>
				  </div>
				)}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default AlertRepository;
